import { Feature, Marker } from "react-mapbox-gl";
import styled from "styled-components";

export const Wrapper = styled.div`
    display: flex;
    flex-direction: row;
    padding-top: 50px;
`;
export const OnlineIcon = styled.span`
    margin-right: 5px;
    display: inline-block;
    width: 10px;
    height: 10px;
    border-radius: 5px;
    background: #34bc55;
`;

export const OfflineIcon = styled.span`
    margin-right: 5px;
    display: inline-block;
    width: 10px;
    height: 10px;
    border-radius: 5px;
    background: #f3471a;
`;
export const DriverList = styled.div`
    margin-right: 10px;
    min-width: 300px;

    .driver-list__title {
        padding: 10px 0;
    }
`;

export const DriverListWrapper = styled.div`
    max-height: calc(100vh - 170px);
    padding-bottom: 40px;
    overflow: auto;
    overflow-x: hidden;
    margin-bottom: 30px;
`;
export const MapWrapper = styled.div`
    width: 100%;
    min-height: 500px;
`;
export const TruckFeature = styled(Feature)`
    display: inline-block;
    width: 12px;
    height: 12px;
    border-radius: 6px;
    background: ${(props) => (props.isOnline ? "#34BC55" : "#F3471A")};
`;
export const DriverMarker = styled(Marker)`
    //transition: transform 0.3s;
    display: inline-block;
    &:after {
        background: ${(props) => (props.isOnline ? "#34BC55" : "#F3471A")};
        width: 10px;
        height: 10px;
        border-radius: 6px;
        content: " ";
        position: absolute;
        top: -3px;
        right: 0;
        opacity: ${(props) => (props.isOnline ? 1 : 1)};
    }
    img {
        width: 30px;
        height: auto;
        opacity: ${(props) => (props.isOnline ? 1 : 1)};
    }
`;
export const Logo = styled.div`
    img {
        width: 30px;
        height: auto;
    }
`;
export const DriverCard = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-radius: 4px;
    padding: 12px 16px;
    cursor: pointer;
    transform: scale(1);
    transition: transform 0.2s;
    &:hover {
        transform: scale(1.05);
    }
    &:active {
        transform: scale(0.95);
    }
    .driver-name {
        font-size: 15px;
        font-weight: bold;
        letter-spacing: 0;
        display: flex;
        align-items: center;
    }

    .last-seen {
        font-weight: 400;
        font-size: 12px;
        letter-spacing: 0;
    }
    .info-row {
        display: flex;
        flex-direction: row;
    }
    .info-label {
        font-weight: 400;
        font-size: 12px;
        color: #a7b1b4;
        letter-spacing: 0;
        margin-right: 6px;
    }

    .info-value {
        font-weight: 400;
        font-size: 12px;
        color: #737880;
        letter-spacing: 0;
    }
`;

export const DriverOverlay = styled.div`
    padding: 16px 10px;
    top: -60px;
    width: 200px;
    position: absolute;
    opacity: 0.73;
    background: rgba(1, 32, 39, 0.9);
    box-shadow: 0 0 17px 9px rgba(33, 87, 102, 0.35);
    border-radius: 4px;
    color: white;
    left: -80px;
`;
